<div class="toast-absolute-container">
  <div aria-live="polite" aria-atomic="true" class="toast-container"></div>
</div>
